var s = (i, n, t) => new Promise((p, r) => {
  var c = (o) => {
    try {
      a(t.next(o));
    } catch (e) {
      r(e);
    }
  }, u = (o) => {
    try {
      a(t.throw(o));
    } catch (e) {
      r(e);
    }
  }, a = (o) => o.done ? p(o.value) : Promise.resolve(o.value).then(c, u);
  a((t = t.apply(i, n)).next());
});
import { selfAxios as f } from "@oppein/op-utils";
function g(i) {
  return s(this, null, function* () {
    const {
      data: n
    } = yield f.post(
      "/ucenterapi/oauth/mobile/login",
      i
    );
    return n;
  });
}
export {
  g as postLogin
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/request/ucenterapi/oauth/mobile/login/post.js
// module id = 1788
// module chunks = 41